import { ServiceBase } from '../../ServiceBase';
import { ExternalBrandInfo, ICmsSegmentationService } from './cms-segmentation.service.interface';
import { action, computed, observable } from 'mobx';
import { IServiceFactoryExtended } from '../../service-factory-extended.interface';
import { CmsSegmentsData } from '../cms-api/cms-api.service.interface';
import { Check } from '@sparkware/app-utils';
import overrideJson from 'json-override';

export class CmsSegmentationService extends ServiceBase implements ICmsSegmentationService {

    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._loadDefaultSegments();
        this._loadSegmentsFromCmsApi();
        this.services.sdk.events.onOAuthStateChanged(this._loadSegmentsFromCmsApi.bind(this));
    }

    private _loadDefaultSegments(): void {
        let segments = this.services.configuration.startupConfiguration?.b2c?.segments;
        if (!Check.isEmpty(segments)) {
            this._setSegments(segments);
        }
    }

    @observable.ref
    segments: CmsSegmentsData = {};

    @action.bound
    private _setSegments(newSegments: CmsSegmentsData): void {
        if (!Check.isObject(newSegments)) {
            this.services.logger.warning(`Received segmentation is not an object: ${newSegments}`);
            this.segments = {};
            return;
        }

        let uniqueSegments = {};

        Object.keys(newSegments).forEach(segmentName => {
            // we append an _ in front of the segment name this way avoiding a name conflict with our own segments like IsVIP.
            uniqueSegments['_' + segmentName] = newSegments[segmentName];
        });

        this.segments = uniqueSegments;
    }

    private async _loadSegmentsFromCmsApi(): Promise<void> {
        let segments = await this.services.cmsApi.getSegments();
        segments = overrideJson(segments, this.services.launcher.getSegmentsOverride() || {});
        this._setSegments(segments);
    }


    private get _isCIS(): boolean {
        if (this.segments && this.segments['_IsCIS']) {
            return true;
        }

        return false;
    }

    private get _isCIP(): boolean {
        if (this.segments && this.segments['_IsCIP']) {
            return true;
        }

        return false;
    }

    get isCstatus(): boolean | null {
        if (Check.isBoolean(this.segments && this.segments['_IsCstatus'])) {
            return this.segments['_IsCstatus'];
        }

        return null;
    }

    get isUKOrIrl(): boolean {
        if (this.segments && this.segments['_IsUkOrIrl']) {
            return true;
        }

        return false;
    }

    get isAppBannerUKorIRL(): boolean {
        if (this.segments && this.segments['_IsAppBannerUKorIRL']) {
            return true;
        }

        return false;
    }

    @computed
    get externalBrand(): ExternalBrandInfo {
        if (this._isCIS) {
            return {
                isExternalBrand: true,
                name: '888sport'
            }
        } else if (this._isCIP) {
            return {
                isExternalBrand: true,
                name: '888poker'
            }
        }
        return { isExternalBrand: false, name: '' };
    }

    get isCisOrCip(): boolean {
        return this._isCIS || this._isCIP;
    }
}


